<template>
    <div>
        <el-table
                ref="classMultipleTable"
                :data="$parent.orderCarts"
                size="medium"
                v-show="$parent.classClick"
                :height="($parent.$parentInfo.clientHeight-600+$parent.$parentInfo.heightChange)/$parent.row-$parent.cartTypeHeight"
                style="width: 100%"
                @selection-change="handleSelectionChange">
            <el-table-column
                    type="selection"
                    width="55">
            </el-table-column>
            <el-table-column
                    prop="semester_name"
                    label="学期"
                    width="180">
            </el-table-column>
            <el-table-column
                    prop="name"
                    label="课程名称"
                    width="180">
            </el-table-column>
            <el-table-column
                    prop="teacher_name"
                    label="老师"
                    width="100">
            </el-table-column>
            <el-table-column
                    prop="time"
                    label="时间"
                    width="180">
            </el-table-column>
            <el-table-column
                    prop="unit_price"
                    label="单价"
                    width="80">
                <template slot-scope="scope">
                    <span v-if="scope.row.section_id!==4 || scope.row.sprintClass==0">{{ scope.row.unit_price|currency('￥',2)}}</span>
                    <span v-else>{{ scope.row.unit_price}}课次</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="class_period"
                    label="购买课次"
                    width="80">
                <template slot-scope="scope">
                    {{ scope.row.cart_period }}/{{ scope.row.class_period }}
                </template>
            </el-table-column>
            <el-table-column
                    label="折扣"
                    width="80">
                <template slot-scope="scope">
                    <span :style="{'color':scope.row.color}">{{ scope.row.discount }}</span>
                </template>
            </el-table-column>
            <el-table-column
                    label="总价"
                    width="120">
                <template slot-scope="scope">
                    <div v-if="scope.row.section_id!==4 || scope.row.sprintClass==0">
                        <span style="color: red" v-if='scope.row.cart_type==="change"'>{{-(scope.row.sum_price_type+scope.row.coupons)|currency('￥',2)}}</span>
                        <span v-else>{{scope.row.sum_price_type-scope.row.coupons-scope.row.use_classHours|currency('￥',2)}}</span>
                    </div>
                    <div v-else>
                        <span style="color: red" v-if='scope.row.cart_type==="change"'>{{-(scope.row.sum_price_type+scope.row.coupons)}}课次</span>
                        <span v-else>{{scope.row.sum_price_type-scope.row.coupons-scope.row.use_classHours}}课次</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                    label="分期金额"
                    width="120">
                <template slot-scope="scope">
                    <span v-if="scope.row.section_id!==4">{{scope.row.installment|currency('￥',2)}}</span>
                    <span v-else>{{scope.row.installment}}课次</span>
                </template>
            </el-table-column>
            <el-table-column
                    label="优惠券抵扣"
                    width="120">
                <template slot-scope="scope">
                    <span v-if="scope.row.section_id!==4">{{ scope.row.coupons |currency('￥',2)}}</span>
                    <span v-else>{{ scope.row.coupons }}课次</span>
                </template>
            </el-table-column>
            <el-table-column
                    label="使用课次金额"
                    width="120">
                <template slot-scope="scope">
                    <span  v-if="scope.row.section_id!==4"> {{ scope.row.use_classHours |currency('￥',2)}}</span>
                    <span  v-else> {{ scope.row.use_classHours}}课次</span>
                </template>
            </el-table-column>
            <el-table-column
                    label="操作"
            >
                <template slot-scope="scope">
                    <el-dropdown trigger="click" size="medium">
                        <el-button icon="el-icon-edit" style="margin-right: 10px"> 编辑</el-button>
                        <el-dropdown-menu slot="dropdown">
                            <!--<el-dropdown-item @click.native="handleCoupon(scope.row)">优惠券</el-dropdown-item>-->
                            <el-dropdown-item @click.native="handleHasTime(scope.row)">占用时间</el-dropdown-item>
                            <el-dropdown-item @click.native="handleDiscountCourse(scope.row)">优惠信息</el-dropdown-item>
                            <el-dropdown-item @click.native="handleChooseClassPlan(scope.row)">挑选课时</el-dropdown-item>
                            <el-dropdown-item @click.native="handleUseClassHour(scope.row)">使用课次</el-dropdown-item>
                            <el-dropdown-item @click.native="handleChangeToTrying(scope.row)">转为试听</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <el-button icon="el-icon-delete" @click="handleDeleteCart(scope.row.id)"
                               :loading="$parent.$parentInfo.studentCart.button_loading">删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    export default {
        name: "ClassCart",
        data() {
            return {

            }
        },
        computed: {

        },
        created() {

        },
        methods: {
            handleDeleteCart(id) {
                this.$confirm('移除后将失去已设定的优惠信息，确定移除?', '提示', {
                    StartReturn: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$parent.$parentInfo.studentCart.button_loading = true;
                    this.$wApi.send(this.$parent.$parentInfo.path, 'deleteCart', {
                        'student_id': this.$parent.$parentInfo.student_id,
                        'cart_id': id,
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },
            //分期付款
            //studentCart
            handleCheckOut() {
                this.$confirm('确认结算?', '提示', {
                    StartReturn: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$parent.$parentInfo.studentCart.button_loading = true;
                    this.$wApi.send(this.$parent.$parentInfo.path, 'checkOutCart', {
                        'change_class_id': this.$parent.$parentInfo.studentCart.change_class_id,
                        'payments': this.$parent.$parentInfo.studentCart.invoiceForm.payment_types,
                        'selections': this.$parent.$parentInfo.studentCart.chosenCart,
                        'student_id': this.$parent.$parentInfo.student_id,
                        'parent_id': this.$parent.$parentInfo.studentCart.invoiceForm.parent_id,
                        'cart_use_lessons': this.$parent.$parentInfo.studentCart.cart_use_lessons,
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },
            //占用学生
            handleHasTime(cart) {
                this.$Win.openModal('Dialog_HasTime', 341, 200, '占用时间', {
                    'cart_id': cart.id,
                    'hasTime': cart.hasTime,
                });
                this.$parent.$parentInfo.studentCart.invoiceForm.payment_types[9].balance = 0;
                this.$parent.$parentInfo.studentCart.cart_use_lessons = [];
                this.$parent.$parentInfo.studentCart.discountChange = false;
                this.$parent.$parentInfo.studentCart.settleJudge = false;
            },
            // 优惠信息
            handleDiscountCourse(cart) {
                this.$Win.openModal('Dialog_DiscountCourse', 450, 400, '优惠', {
                    'cart_id': cart.id,
                    'discount': cart.discount,
                    'giving_period': cart.giving_period,
                    'discount_reason': cart.discount_reason,
                    'possible_auditions_period': cart.possible_auditions_period,
                });
                this.$parent.$parentInfo.studentCart.invoiceForm.payment_types[9].balance = 0;
                this.$parent.$parentInfo.studentCart.cart_use_lessons = [];
                this.$parent.$parentInfo.studentCart.discountChange = false;
                this.$parent.$parentInfo.studentCart.settleJudge = false;
            },
            handleDiscountType() {
                this.$Win.openModal('Dialog_DiscountType', 370, 500, '优惠模板', {
                    'student_id': this.$parent.$parentInfo.student_id,
                    'selections': this.$parent.$parentInfo.studentCart.chosenCart,
                });
                this.$parent.discountChange = true;
            },
            handleChooseClassPlan(cart) {
                if (cart.subject_id != 24) {
                    this.$Win.openModal('Dialog_ChooseClassPlan', 600, 450, '挑选课时', {
                        'cart_id': cart.id,
                    });
                } else {
                    this.$Win.openModal('Dialog_ChooseWanTuoClassPlan', 600, 450, '挑选晚托课时', {
                        'cart_id': cart.id,
                    });

                }
                this.$parent.$parentInfo.studentCart.invoiceForm.payment_types[9].balance = 0;
                this.$parent.$parentInfo.studentCart.cart_use_lessons = [];
                this.$parent.$parentInfo.studentCart.discountChange = false;
                this.$parent.$parentInfo.studentCart.settleJudge = false;
            },
            handleCoupon(cart) {
                this.$Win.openModal('Dialog_ChooseCoupon', 370, 300, '优惠券', {
                    'cart_id': cart.id,
                    'sum_price': cart.cart_period * cart.original_unit_period_price
                });
                this.$parent.discountChange = true;
            },
            handleUseClassHour(cart){
                this.$Win.openModal('Dialog_UseClassHour', 700, 900, '使用课次', {'cart_id':cart.id});
            },
            handleSelectionChange(val) {
                this.$parent.multipleSelection = val;
                this.calculateCart();
            },
            calculateCart() {
                let arr = [];
                let vm = this;
                let checkInstallmentCount = 0;
                let checkUnInstallmentCount = 0;
                // vm.$parentInfo.studentCart.sumPay = 0;
                vm.$parent.$parentInfo.studentCart.installmentJudge = false;
                let studentCart = this.$parent.multipleSelection;
                for (let i in studentCart) {
                    arr.push(studentCart[i].id);
                    if (studentCart[i].cart_type === 'stage') {
                        vm.$parent.$parentInfo.studentCart.installmentJudge = true;
                    }

                }
                if (!this.$parent.discountChange) {
                    vm.$parent.$parentInfo.studentCart.settleJudge = false;
                }

                vm.$parent.$parentInfo.studentCart.cart_use_lessons = [];

                this.$parent.$parentInfo.studentCart.chosenCart = arr;
                this.$parent.$parentInfo.studentCart.chosenCart.forEach((item) => {
                    if (this.$parent.$parentInfo.studentCart.studentCartData[item].cart_type == 'stage'
                        || this.$parent.$parentInfo.studentCart.studentCartData[item].cart_type == 'staging') {
                        checkInstallmentCount += 1;
                    } else {
                        checkUnInstallmentCount += 1
                    }
                });
                if (checkInstallmentCount != 0 && checkUnInstallmentCount != 0) {
                    this.$message.error('分期与未分期的课不能一起结算');
                    this.$parent.$parentInfo.studentCart.settleCheck = false;
                } else {
                    this.$parent.$parentInfo.studentCart.settleCheck = true;
                }
            },
            handleChangeToTrying(cart){
                this.$confirm('确认转为试听?', '提示', {
                    StartReturn: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$parent.$parentInfo.studentCart.button_loading = true;
                    this.$wApi.send(this.$parent.$parentInfo.path, 'cart_change_to_trying', {
                        'student_id': this.$parent.$parentInfo.student_id,
                        'cart_id': cart.id,
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            }
        }
    }
</script>

<style scoped>

</style>